import { Edit } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const EditPreparatoryCourses = () => {
  return (
    <Edit
      title="Редакция на подготвителни курсове"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <SaveForm isEdit={true} />
    </Edit>
  );
};
export default EditPreparatoryCourses;
